var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 331,
    viewBox: "0 0 308 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 251.246L6 104.351V42.5432L50.1487 0H111.154L154.5 42.5432V251.246Z",
    fill: "#FBE6DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 251.246L6 104.351V42.5432L50.1487 0H111.154L154.5 42.5432V251.246Z",
    fill: "#FFB1B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 251.246L303 104.351V42.5432L258.851 0H197.846L154.5 42.5432V251.246Z",
    fill: "#FBE6DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 251.246L303 104.351V42.5432L258.851 0H197.846L154.5 42.5432V251.246Z",
    fill: "#FFB1B1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 251.246L303 104.351V42.5432L258.852 0H197.846L154.5 42.5432V251.246Z",
    fill: "#FBE6DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.658 72.8384H154.928H173.12V177.947H154.928H134.658V72.8384Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.393 143.941V105.814H207.423V143.941H101.393Z",
    fill: "#FEFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.621 72.8384H154.869V177.947H134.621V72.8384Z",
    fill: "#FBEFE7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.393 143.941V105.814H154.869V124.877V143.941H101.393Z",
    fill: "#FBEFE7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 154,
    cy: 306,
    rx: 154,
    ry: 25,
    fill: "url(#paint0_radial_839_14411)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_839_14411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154 306) rotate(90) scale(25 154)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.f5f86f222d86e175ce9be01fffe94774.svg";
export { ForwardRef as ReactComponent };